// src/services/servicesService.js
import apiClient from './apiClient.js'

export const servicesService = {
    // Get services for public website (your existing function)
    getServices(params = {}) {
        return apiClient.get('/services', { params })
    },

    // Get services for admin panel (new function)
    getServicesAdmin(params = {}) {
        return apiClient.get('/services/admin', { params })
    },

    getServiceBySlug(slug) {
        return apiClient.get(`/services/slug/${slug}`)
    },

    createService(data) {
        return apiClient.post('/services', data)
    },

    updateService(id, data) {
        return apiClient.put(`/services/${id}`, data)
    },

    // Toggle service status (new function)
    toggleServiceStatus(id) {
        return apiClient.patch(`/services/${id}/toggle-status`)
    },

    deleteService(id) {
        return apiClient.delete(`/services/${id}`)
    },
}